
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/sentry.client.config.ts")
            }
          });